import type { BrandLabel } from "../../theme/brand";
import { PrevioWordmark } from "./PrevioWordmark";

/**
 * The rail's brand: the product's name, or a partner's wordmark in its place
 * with the name kept for a screen reader, and the co-brand line under it.
 * One component for the rail and for what stands in for it, so the two draw
 * the brand alike.
 */
export function BrandHeading({ label }: { label: BrandLabel }) {
    return (
        <>
            <h1 className="text-base font-semibold leading-tight truncate">
                {label.mark === "previo" ? (
                    <>
                        <span className="sr-only">{label.line1}</span>
                        {/* About the 32px Previo draws it at in its own bar. */}
                        <PrevioWordmark className="block h-7 w-auto" />
                    </>
                ) : (
                    label.line1
                )}
            </h1>
            {label.line2 && (
                <p className="text-xs text-sidebar-foreground/70 leading-tight truncate">{label.line2}</p>
            )}
        </>
    );
}
